
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 18 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.7727 7.86368H1.22728C0.549817 7.86368 0 8.4135 0 9.09095V9.90909C0 10.5865 0.549817 11.1364 1.22728 11.1364H16.7727C17.4502 11.1364 18 10.5865 18 9.90909V9.09095C18 8.4135 17.4502 7.86368 16.7727 7.86368Z"}}),_c('path',{attrs:{"d":"M7.36362 1.72728V17.2727C7.36362 17.9502 7.91343 18.5 8.59089 18.5H9.40903C10.0865 18.5 10.6363 17.9502 10.6363 17.2727V1.72728C10.6363 1.04982 10.0865 0.5 9.40903 0.5H8.59089C7.91343 0.5 7.36362 1.04982 7.36362 1.72728Z"}})])
          )
        }
      }
    